import { z } from 'zod';

export const zodDeleteUserIdentityProviderLinkAdminEndpointSchema = z.tuple([
  z.literal('vadmin'),
  z.literal('users'),
  z.uuid(),
  z.literal('identity_provider_links'),
  z.string().min(1),
]);
